import * as React from "react"

import { cn } from "../../lib/utils"

type TextareaProps = React.ComponentProps<"textarea"> & {
  /** Show a live `used/max` character counter anchored to the bottom-right corner inside the field. Requires `maxLength`. */
  showCount?: boolean
}

function Textarea({ className, showCount, ...props }: TextareaProps) {
  const textarea = (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-border focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive disabled:bg-input/70 placeholder:text-muted-foreground flex field-sizing-content min-h-16 w-full rounded-lg border bg-background dark:bg-input shadow-[var(--shadow-field)] px-2.5 py-2 text-base text-input-foreground transition-colors outline-none focus-visible:ring-3 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-3 md:text-sm",
        showCount && typeof props.maxLength === "number" && "pb-6",
        className
      )}
      {...props}
    />
  )

  if (!showCount || typeof props.maxLength !== "number") return textarea

  const length = typeof props.value === "string" || typeof props.value === "number" ? String(props.value).length : 0

  return (
    <div className='relative'>
      {textarea}
      <span
        aria-hidden='true'
        className='text-muted-foreground pointer-events-none absolute bottom-2 right-2.5 text-xs tabular-nums'
      >
        {length}/{props.maxLength}
      </span>
    </div>
  )
}

export { Textarea }
